/// <reference path="ListBase.js" />

class NewspaperEditionList extends ListBase {
	constructor(el, options) {
		super(el, Object.assign({ pagingEffect: 'vertSlide' }, options));
	}

	loadPage(page) {
		super.loadPage(page);
		this.standardJSONRequest(this.options.url.replace('PLH_pagenum', page));
	}
}
